import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class Error {
}
class ErrorDetails {
}

class RoleHintRequest {
}
class ScheduleOptionsRequest {
    constructor() {
        this.staggerDates = true;
    }
}
class EnumBase {
    constructor(name, id) {
        this.name = name;
        this.id = id;
    }
}
class ScheduleProjectType extends EnumBase {
    constructor(name, id) {
        super(name, id);
    }
    static GetAll() {
        let all = [ScheduleProjectType.NotScheduled, ScheduleProjectType.StartNow, ScheduleProjectType.StartAt, ScheduleProjectType.DueBy, ScheduleProjectType.ManualAll, ScheduleProjectType.ManualSome, ScheduleProjectType.FullRange, ScheduleProjectType.NextMonth];
        return all;
    }
    static FromId(pid) {
        let result = this.GetAll().find((x) => x.id == pid);
        return result;
    }
}
ScheduleProjectType.NotScheduled = new ScheduleProjectType("Not Scheduled", "NotScheduled");
ScheduleProjectType.StartNow = new ScheduleProjectType("Start Now", "StartNow");
ScheduleProjectType.StartAt = new ScheduleProjectType("Start At", "StartAt");
ScheduleProjectType.DueBy = new ScheduleProjectType("Due By", "DueBy");
ScheduleProjectType.NextMonth = new ScheduleProjectType("Next Month", "NextMonth");
ScheduleProjectType.ManualAll = new ScheduleProjectType("Manual All", "ManualAll");
ScheduleProjectType.ManualSome = new ScheduleProjectType("Manual Some", "ManualSome");
ScheduleProjectType.FullRange = new ScheduleProjectType("Full Range", "FullRange");
class InstanceType extends EnumBase {
    constructor(name, id) {
        super(name, id);
    }
    static GetAll() {
        let all = [InstanceType.SingleInstance, InstanceType.MultiInstance];
        return all;
    }
    static FromId(pid) {
        let result = this.GetAll().find((x) => x.id == pid);
        return result;
    }
}
InstanceType.SingleInstance = new InstanceType("Single Instance", "SingleInstance");
InstanceType.MultiInstance = new InstanceType("Multi Instance", "MultiInstance");
InstanceType.Unknown = new InstanceType("Unknown Instance Type", "UnknownInstanceType");

class FileContentType {
    constructor(extension, mimeType) {
        this.extension = extension;
        this.mimeType = mimeType;
    }
}
class PlatformUploadResponse {
    constructor(assetFile, progress, inProgress, wasSuccessful) {
        this.assetFile = assetFile;
        this.progress = progress;
        this.wasSuccessful = wasSuccessful;
        this.inProgress = inProgress;
    }
}
class WorkType {
    constructor(name, id) {
        this.name = name;
        this.id = id;
    }
}
class CommonWorkTypes {
}
CommonWorkTypes.GeneralAI = new WorkType("General AI", "654e675ce41441565f852c2d");
CommonWorkTypes.KeywordsOutlineAIWork = new WorkType("Keywords > Outline AI Work", "655f37b3070e1a692d48d64b");
CommonWorkTypes.OutlineKeywordCopyAIWork = new WorkType("Outline & Keywords > Copy AI Work", "655f37d5070e1a692d48d64c");
CommonWorkTypes.CopyKeywordsOptimizationAIWork = new WorkType("Copy Keywords Optimization AI Work", "655f37ff070e1a692d48d64d");
CommonWorkTypes.CopyTweetsAIWork = new WorkType("Copy > Tweets AI Work", "6560a31ebc364729a6ac0af3");
CommonWorkTypes.TitleImageAIWork = new WorkType("Title > Image AI Work", "6560dca0a7298e47bccc8626");
CommonWorkTypes.TextWork = new WorkType("Text Work", "6558db028719f0c582c6ad85");
CommonWorkTypes.AttachmentWork = new WorkType("Attachment Work", "6558db0b8719f0c582c6ad86");
CommonWorkTypes.Planning = new WorkType("Planning", "5a3278190adf480001b52ab4");
CommonWorkTypes.RevisionApproval = new WorkType("Revision Approval", "5c58280eb2f3f80001708c7b");
CommonWorkTypes.RevisionEditing = new WorkType("Revision Editing", "5c58281bb2f3f80001708c7c");
CommonWorkTypes.PublishContentLibrary = new WorkType("Publish Content Library", "62d1a0cb6b6737fb1a6a207a");
CommonWorkTypes.PublishLocationUpdate = new WorkType("Publish Location Update", "632ad2d68e0e1e560f4a2b94");
CommonWorkTypes.Publish = new WorkType("Publish", "5c9e0055d3476e0001b4e8ae");
CommonWorkTypes.ProductionWork = new WorkType("Production Work", "61b79b3ba26b06fe16594771");
CommonWorkTypes.KeywordSEOTitleAIWork = new WorkType("Keyword > SEO Title AI Work", "656498684d49c1ab51c10e87");
CommonWorkTypes.TitleCopyKeywordsMetaDataAIWork = new WorkType("Title & Copy & Keywords > Metadata AI Work", "656498824d49c1ab51c10e88");
CommonWorkTypes.KeywordKeywordsDenstiyWork = new WorkType("Keyword > Keywords Density Work", "65687bc8894b03a53c5d8e49");
CommonWorkTypes.CopyLinkedInPostAIWork = new WorkType("Copy > LinkedIn Post AI Work", "6569cd2e1c229511ad6e950b");
CommonWorkTypes.OutlineLineCopyAIWork = new WorkType("Outline > Copy AI Work", "6569cd461c229511ad6e950c");
CommonWorkTypes.TopicOutlineAIWork = new WorkType("Topic > Outline AI Work", "6569cd611c229511ad6e950d");
CommonWorkTypes.TopicTopicsAIWork = new WorkType("Topic > Topics AI Work", "6569cda31c229511ad6e950e");
CommonWorkTypes.KeywordSEOTitlesAIWork = new WorkType("Keyword > SEO Titles AI Work", "65687bc8894b03a53c5d8e49");
CommonWorkTypes.TextSubTextsTextWork = new WorkType("Text SubTexts > Text Work", "6569ce051c229511ad6e9510");
CommonWorkTypes.TextsTextWork = new WorkType("Texts > Text Work", "6569ce151c229511ad6e9511");
CommonWorkTypes.AttachmentsAttachmentWork = new WorkType("Attachments > Attachment Work", "6569ce251c229511ad6e9512");
CommonWorkTypes.PlainTextToKeywordsDensityWork = new WorkType("Plain Text > Keywords Density Work", "6569e9124a5fb38546dad0cd");
CommonWorkTypes.SampleCopyWritingBriefAIWork = new WorkType("Sample Copy > Writing Brief AI Work", "656ddd73650cdaf4ea290b27");
CommonWorkTypes.CopyFactReferencesAIWork = new WorkType("Copy > Fact References AI Work", "657078924d026a1082e31dd4");
CommonWorkTypes.CopyTargetAudienceBriefAIWork = new WorkType("Copy > Target Audience Brief AI Work", "65774842ee2bd7814f8a1986");
CommonWorkTypes.CopyGermanCopyAIWork = new WorkType("Copy > German Copy AI Work", "657b42133b1362e6c1f4a6b0");
CommonWorkTypes.CopyImagesAIWork = new WorkType("Copy > Images AI Work", "65958013983a0b3ab31849b5");
CommonWorkTypes.AttachmentToImageDescriptionAIWork = new WorkType("Attachment > Image Description AI Work", "65a8273b5e2b2d913d51a985");
CommonWorkTypes.AttachmentToAttachmentResize = new WorkType("Attachment > Attachment Resize", "65aedc63b05b5c186d4464bf");
CommonWorkTypes.GenericProcessWork = new WorkType("Generic Process Work", "65a927b47a50caac5a3bd1ef");
CommonWorkTypes.GenericProcessWorkManualSelection = new WorkType("Generic Process Work - Manual Selection", "65bb72cf3679314c37d16155");

var PermissionType;
(function (PermissionType) {
    PermissionType[PermissionType["Unknown"] = -1] = "Unknown";
    PermissionType[PermissionType["Disabled"] = 0] = "Disabled";
    PermissionType[PermissionType["SaaSAdmin"] = 1] = "SaaSAdmin";
    PermissionType[PermissionType["SaaSManager"] = 2] = "SaaSManager";
    PermissionType[PermissionType["SaaSContributor"] = 3] = "SaaSContributor";
    PermissionType[PermissionType["SaaSViewer"] = 4] = "SaaSViewer";
    PermissionType[PermissionType["BraftonManager"] = 12] = "BraftonManager";
    PermissionType[PermissionType["BraftonContributor"] = 13] = "BraftonContributor";
    PermissionType[PermissionType["BraftonViewer"] = 14] = "BraftonViewer";
})(PermissionType || (PermissionType = {}));
class PermissionTypeFriendlyEnum {
}

class InputType extends EnumBase {
    constructor(name, id) {
        super(name, id);
    }
    static GetAll() {
        let all = [InputType.TextSet, InputType.AssetSet, InputType.String];
        return all;
    }
    static FromId(pid) {
        let result = this.GetAll().find((x) => x.id == pid);
        return result;
    }
}
InputType.TextSet = new InputType("TextSet", "TextSet");
InputType.AssetSet = new InputType("AssetSet", "AssetSet");
InputType.String = new InputType("String", "String");
InputType.Integer = new InputType("Integer", "Integer");
InputType.Unknown = new InputType("Unknown Input Type", "UnknownInputType");
//export interface OutputFunctionDefintion extends OutputDefinition {
//  functionName: string;
//  functionDescription: string;
//  functionParameters: string;
//}

class JsonEncryptDecrypt {
    constructor() { }
    findReferences(obj, catalog) {
        if (obj && typeof obj === 'object') {
            const id = obj.$id;
            if (typeof id === 'string') {
                catalog[id] = obj;
            }
            if (Object.prototype.toString.apply(obj) === '[object Array]') {
                let i;
                for (i = 0; i < obj.length; i += 1) {
                    this.findReferences(obj[i], catalog);
                }
            }
            else {
                for (const name in obj) {
                    if (obj.hasOwnProperty(name)) {
                        if (typeof obj[name] === 'object') {
                            this.findReferences(obj[name], catalog);
                        }
                    }
                }
            }
        }
    }
    resolveReferences(obj, catalog) {
        if (obj && typeof obj === 'object') {
            let i;
            let item;
            let id;
            if (Object.prototype.toString.apply(obj) === '[object Array]') {
                for (i = 0; i < obj.length; i += 1) {
                    item = obj[i];
                    if (item && typeof item === 'object') {
                        id = item.$ref;
                        if (typeof id === 'string') {
                            obj[i] = catalog[id];
                        }
                        else {
                            obj[i] = this.resolveReferences(item, catalog);
                        }
                    }
                }
            }
            else if (obj.$values && Object.prototype.toString.apply(obj.$values) === '[object Array]') {
                const arr = new Array();
                for (i = 0; i < obj.$values.length; i += 1) {
                    item = obj.$values[i];
                    if (item && typeof item === 'object') {
                        id = item.$ref;
                        if (typeof id === 'string') {
                            arr[i] = catalog[id];
                        }
                        else {
                            arr[i] = this.resolveReferences(item, catalog);
                        }
                    }
                    else {
                        arr[i] = item;
                    }
                }
                obj = arr;
            }
            else {
                let name;
                for (name in obj) {
                    if (obj.hasOwnProperty(name)) {
                        if (typeof obj[name] === 'object') {
                            item = obj[name];
                            if (item) {
                                id = item.$ref;
                                if (typeof id === 'string') {
                                    obj[name] = catalog[id];
                                }
                                else {
                                    obj[name] = this.resolveReferences(item, catalog);
                                }
                            }
                        }
                    }
                }
            }
        }
        return obj;
    }
    getDecycledCopy(obj, catalog) {
        let i;
        let name;
        let nu;
        switch (typeof obj) {
            case 'object':
                if (obj === null ||
                    obj instanceof Boolean ||
                    obj instanceof Date ||
                    obj instanceof Number ||
                    obj instanceof RegExp ||
                    obj instanceof String) {
                    return obj;
                }
                for (i = 0; i < catalog.length; i += 1) {
                    if (catalog[i] === obj) {
                        return { $ref: i.toString() };
                    }
                }
                obj.$id = catalog.length.toString();
                catalog.push(obj);
                if (Object.prototype.toString.apply(obj) === '[object Array]') {
                    nu = [];
                    for (i = 0; i < obj.length; i += 1) {
                        nu[i] = this.getDecycledCopy(obj[i], catalog);
                    }
                }
                else {
                    nu = {};
                    for (name in obj) {
                        if (Object.prototype.hasOwnProperty.call(obj, name)) {
                            nu[name] = this.getDecycledCopy(obj[name], catalog);
                        }
                    }
                }
                return nu;
            case 'number':
            case 'string':
            case 'boolean':
            default:
                return obj;
        }
    }
    decycle(obj) {
        const catalog = [];
        const newObj = this.getDecycledCopy(obj, catalog);
        return newObj;
    }
    retrocycle(obj) {
        const catalog = [];
        this.findReferences(obj, catalog);
        return this.resolveReferences(obj, catalog);
    }
}
JsonEncryptDecrypt.ɵfac = function JsonEncryptDecrypt_Factory(t) { return new (t || JsonEncryptDecrypt)(); };
JsonEncryptDecrypt.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: JsonEncryptDecrypt, factory: JsonEncryptDecrypt.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonEncryptDecrypt, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

const services = [];
const utils = [];
class CommonFrameworkLibraryModule {
}
CommonFrameworkLibraryModule.ɵfac = function CommonFrameworkLibraryModule_Factory(t) { return new (t || CommonFrameworkLibraryModule)(); };
CommonFrameworkLibraryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CommonFrameworkLibraryModule });
CommonFrameworkLibraryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonFrameworkLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [services, utils],
                imports: [CommonModule,],
                exports: [CommonModule, services, utils],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CommonFrameworkLibraryModule, { imports: [CommonModule], exports: [CommonModule] }); })();

/*
 * Public API Surface of common-framework-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommonFrameworkLibraryModule, CommonWorkTypes, EnumBase, Error, ErrorDetails, FileContentType, InputType, InstanceType, JsonEncryptDecrypt, PermissionType, PermissionTypeFriendlyEnum, PlatformUploadResponse, RoleHintRequest, ScheduleOptionsRequest, ScheduleProjectType, WorkType };
